<script>
    import FooterBottomText from "@/components/footer/FooterBottomText";
    import FooterPaymentIcons from "@/components/PaymentIcons";

    export default {
        name: "TheFooterBottom",
        components: {
            FooterBottomText,
            FooterPaymentIcons,
        },
    };
</script>

<template>
    <div class="the-footer-bottom">
        <div class="l-container">
            <div class="the-footer-bottom__inner">
                <div class="the-footer-bottom__text">
                    <footer-bottom-text
                        title="Оператор магазина ТОО «МИКУ»"
                        subtitle="Республика Казахстан, г. Алматы, Жетысуский р-н, ул. Потанина 47/26"
                    ></footer-bottom-text>
                </div>

                <div class="the-footer-bottom__icons">
                    <footer-payment-icons
                        :exclude="['cash', 'mir', 'sbp', 'tinkoff-pay']"
                    ></footer-payment-icons>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .the-footer-bottom {
        padding: 30px 0 40px;
        color: #fff;
        background-color: #000;
        @include bp($bp-desktop-sm) {
            padding: 20px 0 20px;
        }
    }

    .the-footer-bottom__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
        }
    }

    .the-footer-bottom__text {
        text-align: center;
        @include bp($bp-desktop-sm) {
            text-align: left;
        }
    }

    .the-footer-bottom__icons {
        max-width: 260px;
        margin: 0 auto;
        @include bp($bp-desktop-sm) {
            max-width: 100%;
            margin: 0;
        }
    }
</style>
